<template>
  <canvas class="canvas-class" ref="my-canvas" width="1024" height="512"></canvas>
</template>

<script>
import 'yuki-createjs'
/* eslint-disable */

const preload = new createjs.LoadQueue()

export default {
  props: ['texts'],
  components: {},
  name: 'WheelOfFortune',
  data: function () {
    return {
      queue: null,
      stage: null,
      wheel: null,
      result: null,
      colors: ['black', 'keltainen', 'punainen', 'vihrea', 'sininen', 'violetti', 'keltainen', 'punainen', 'vihrea', 'sininen', 'violetti']
    }
  },
  methods: {
    spin: function () {
      var r = this.wheel.rotation
      var sector = Math.random() * 360

      createjs.Tween.get(this.wheel, {loop:false})
        .to({rotation: r + 360 }, 1000, createjs.Ease.quadIn)
        .to({rotation: r + 4*360 + sector}, 4000, createjs.Ease.quadOut)
        .wait(500)
        .call(this.stopped)
        // soundEffect( "wheelspin" );
    },
    stopped: function () {
      var wheelrounds = Math.floor( this.wheel.rotation / 360 );
      var thesector = (this.wheel.rotation - wheelrounds*360) / (360/11);
      this.result = this.colors[ Math.ceil(thesector) - 1 ];
      this.$emit('done', this.result)
    },
    handleFileComplete: function (event) {
      this.wheel = new createjs.Bitmap(preload.getResult('wheel'))
      this.wheel.regX = this.wheel.getBounds().width / 2
      this.wheel.regY = this.wheel.getBounds().height / 2
      this.wheel.scaleX = this.wheel.scaleY = 1
      this.wheel.x = 512
      this.wheel.y = 512
      this.stage.addChild( this.wheel )

      var wheelpointer = new createjs.Bitmap(preload.getResult('pointer'))
      wheelpointer.regX = wheelpointer.getBounds().width / 2
      wheelpointer.x = 512
      wheelpointer.y = 0 
      wheelpointer.scaleX = wheelpointer.scaleY = 1
      this.stage.addChild(wheelpointer)
      this.stage.update()
    }
  },
  mounted () {
    this.stage = new createjs.Stage(this.$refs['my-canvas'])
    createjs.Ticker.setFPS(60)
    createjs.Ticker.addEventListener('tick', this.stage)
    let assetPah = './static/'
    assetPah = '/wp-content/themes/kopiraittilankoulu/helpolla/static/'
    let assetList = [
      {src: assetPah + 'onnenpyora.png', id: "wheel"},
      {src: assetPah + 'onnenpyoranuoli.png', id: "pointer"}
    ]
    preload.addEventListener('complete', (e) => { this.handleFileComplete(e) })
    preload.loadManifest(assetList)
  }
}
</script>

<style>
.canvas-class{
  max-width: 100%;
  max-height: 30vh;
  margin-bottom: -5px;
}
</style>



// WEBPACK FOOTER //
// src/components/WheelOfFortune.vue